import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function initMediaScaleEffect() {
  // Select all '.c-large-feature_media' elements
  let mediaElements = document.querySelectorAll('.c-large-feature_media');

  mediaElements.forEach(media => {
    // Set initial scale
    gsap.set(media, {
      scale: 1.5, // Start with scale 1.5
      willChange: 'transform'
    });

    // Create ScrollTrigger animation
    gsap.timeline({
      scrollTrigger: {
        trigger: media, // The element that triggers the scroll animation
        scrub: true, // Smooth the animation according to scroll speed
        start: 'top bottom', // Start animation when the top of the section reaches the bottom of the viewport
        end: 'bottom top', // End animation when the bottom of the section reaches the top of the viewport
        markers: false, // Add markers if you need debugging
      }
    })
    .to(media, {
      scale: 1, // Scale the media down to 1 as it scrolls
      ease: 'none' // No easing for a smooth transition
    });
  });
}

export { initMediaScaleEffect };
